<template>
  <focus-lock>
    <el-dialog
      ref="membersInvitationDialog"
      v-loading="loading"
      :show-close="false"
      custom-class="member-invitation-dialog"
      :visible.sync="dialogVisible"
      :before-close="onClose"
      :center="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @submit.prevent.native="submitInvitation"
      @opened="dialogOpen('membersInvitationDialog')"
    >
      <div class="body">
        <h1>Invite new member</h1>
        <p class="pb-3">
          Enter new member’s email address below. They will receive an invite into the network to complete their own profile.
        </p>
        <el-form
          id="invitationForm"
          ref="invitationForm"
          :rules="rules"
          :model="form"
          autocomplete="false"
          @submit.native.prevent
        >
          <validation-errors
            v-if="validationErrors.length"
            :errors="validationErrors"
          ></validation-errors>
          <el-row>
            <el-col>
              <el-form-item
                id="email"
                prop="email"
              >
                <template slot="label">
                  Email Address
                  <span
                    class="sr-only"
                    aria-live="polite"
                    :hidden="!hasInlineValidationErrorFor('email')"
                    v-text="getInlineValidationErrorFor('email')"
                  ></span>
                </template>
                <el-input v-model="form.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="d-flex justify-content-center ">
            <el-button
              :disabled="loading"
              class="btn-cancel"
              @click="onClose"
            >
              Go back
            </el-button>
            <el-button
              :disabled="loading"
              type="primary"
              native-type="submit"
              class="btn-submit"
            >
              Send invite
            </el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </focus-lock>
</template>
  
<script>
import gsApi from "@/services/gs.api";
import { validateEmail } from '@/helpers/validators'
import validationErrors from '@/components/partials/validation-errors'
import inlineValidationErrorsMixin from '@/mixins/inlineValidationErrorsMixin'
export default {
  components: {
    validationErrors
  },
  mixins: [inlineValidationErrorsMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validationErrors: [],
      loading: false,
      form: {
        email: null,
      },
      dialogVisible: false,
      rules: {
        email:[
          {validator: validateEmail, required: true}
        ],
      }
    };
  },
  watch:{
    visible(){
      this.dialogVisible = this.visible;
    }
  },
  created(){
    this.dialogVisible = this.visible;
  },
  methods: {
    submitInvitation() {
      this.$refs["invitationForm"].validate(valid => {
        if (valid) {
          this.loading = true;
          gsApi.organisation
            .invite(this.form)
            .then((response) => {
              
              this.validationErrors = []
              this.$refs.invitationForm.resetFields()
              this.$refs.invitationForm.clearValidate()
              this.onClose();
              if(response.data.isJoined){
                this.$emit('member-invited')
              }
              
              this.$alert(
                response.data?.message,
                "Success",
                {
                  confirmButtonText: "Close",
                  showClose: false,
                  customClass: "notification-modal"
                }
              ).then(() => {
              });
            })
            .catch(error => {
              this.validationErrors = [];

              if (error.response && (error.response.status == 422 || error.response.status == 403) && error.response.data) {
                if(error.response.status == 422){
                  let errors = error.response.data.errors;
                  for (let [key, value] of Object.entries(errors)) {
                    let obj = {}
                    obj.id = key;
                    obj.message = value[0];
                    this.validationErrors.push(obj);
                  }
                  window.scrollTo({top: 0, behavior: 'smooth'});
                }else{
                  
                  this.$refs.invitationForm.resetFields()
                  this.$refs.invitationForm.clearValidate()
                  this.onClose();
                  this.$alert(error.response.data.error.message, 'Error', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
                }
              } else {
                this.$alert('There are errors in the form, please fix these errors and try again.', 'Error', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {

          this.validationErrors = [];
          this.$refs.invitationForm.fields.forEach(field => {
            if(field.validateState == 'error') {
              let obj = {}
              obj.id = field.labelFor;
              obj.message = field.validateMessage;
              this.validationErrors.push(obj);
            }
          });

          this.$nextTick(() => {
            document.getElementById('formErrorBlock').scrollIntoView({ behavior: 'smooth', block: 'start' })
            let text = document.getElementById("invitationForm").getElementsByClassName('el-form-item__error')[0].textContent
            this.$announcer.set(text)
          })
        }
      });
    },
    onClose() {
      this.dialogVisible = false;
      this.$emit("close");
    },
    handleSubmitFormFieldInput () {
      this.handleSingleFormFieldInput('submitInvitation');
    },
  }
};
</script>
  